import { ProgramTerm } from '@/queries/academic_terms/schema'
import { BookText, CalendarIcon } from 'lucide-react'
import React from 'react'
import { dateToYYYYMMDD } from '../utils'

type Props = {
  period: ProgramTerm
  actionContent: React.ReactNode
}

export default function DistributionperiodItem(props: Props) {
  const { period, actionContent } = props
  return (
    <div className="flex items-center justify-between w-full  py-4">
      <div className="flex items-center gap-2">
        <div className="h-10 w-10 rounded-xl bg-gray-100 border-gray-200 border inline-flex items-center justify-center ">
          <BookText className="text-primary-600 size-5" />
        </div>
        <div className="text-lg font-medium text-gray-900 w-max">
          {period.name}
        </div>
      </div>
      <div className="flex items-center justify-between w-full max-w-lg">
        <div className="w-auto">
          <div className="text-sm text-gray-600 font-normal w-full">
            Start Date:
          </div>
          <div className="font-medium flex w-max items-center gap-2">
            <CalendarIcon className="w-4" />{' '}
            {period.awarding_period_start_date
              ? dateToYYYYMMDD(period.awarding_period_start_date)
              : 'Not Set'}
          </div>
        </div>
        <div className="w-full h-[1px] bg-gray-200 mx-10"></div>
        <div className="w-auto">
          <div className="text-sm text-gray-600 font-normal text-end">
            End Date:
          </div>
          <div className="font-medium flex items-center w-max gap-2">
            <CalendarIcon className="w-4" />{' '}
            {period.awarding_period_end_date
              ? dateToYYYYMMDD(period.awarding_period_end_date)
              : 'Not Set'}
          </div>
        </div>
      </div>
      <div>{actionContent}</div>
    </div>
  )
}
